import { Component, Input, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { HtlService } from "../../htl/htl.service";
import { process, State } from "@progress/kendo-data-query";
import { DataStateChangeEvent, ExcelExportEvent, GridDataResult } from "@progress/kendo-angular-grid";
import { DatePipe } from "@angular/common";
import { Helicopter } from "../../shared/models/helicopter.model";

@Component({
    selector: "app-daily-checks-table",
    templateUrl: "./daily-checks-table.component.html",
    styleUrl: "./daily-checks-table.component.scss",
    providers: [DatePipe],
    standalone: false,
})
export class DailyChecksTableComponent implements OnInit, OnChanges {
    @Input({ required: true }) aircraft: Helicopter;

    public gridView: GridDataResult;
    public gridData = [];
    public data: any[] = [];

    endDate = new Date();
    startDate = new Date(new Date().getFullYear(), 0, 1);
    today = new Date();

    filename: string;

    public pageSizes = [25, 50, 100, 200];

    public state: State = {
        skip: 0,
        take: this.pageSizes[0],
    };

    constructor(
        private datePipe: DatePipe,
        private _htlService: HtlService,
    ) {
        this.gridData = [
            { field: "date", title: "DAILYCHECKS.date", format: "dd-MM-yyyy" },
            { field: "time", title: "DAILYCHECKS.time", format: "HH:mm" },
            { field: "user", title: "DAILYCHECKS.user" },
        ];
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes["aircraft"] && changes["aircraft"].currentValue) {
            this.fetchDailyChecks();
        }
    }

    ngOnInit() {
        this.fetchDailyChecks();
    }

    onExcelExport(e: ExcelExportEvent) {
        const rows = e.workbook.sheets[0].rows;

        // set alternating row color
        let altIdx = 0;
        rows.forEach((row) => {
            if (row.type === "data") {
                if (altIdx % 2 !== 0) row.cells.forEach((cell) => (cell.background = "#f2f7ff"));
                altIdx++;
            }
        });
    }

    onDateChange() {
        if ((!this.startDate && !this.endDate) || (this.startDate && this.endDate)) {
            this.fetchDailyChecks();
        }
    }

    private fetchDailyChecks() {
        return this._htlService.getDailyChecks(this.aircraft.id, this.startDate, this.endDate).subscribe((result) => {
            this.data = result.map((r) => ({
                date: new Date(r.performedAt),
                time: new Date(r.performedAt),
                user: r.firstName + " " + r.lastName,
            }));

            this.filename = "DailyChecks_" + this.aircraft.registrationMark.trim();
            if (this.data.length > 0) {
                if (!this.startDate) {
                    this.startDate = new Date(Math.min(...result.map((r) => new Date(r.performedAt).getTime())));
                }
                if (!this.endDate) {
                    this.endDate = new Date(Math.max(...result.map((r) => new Date(r.performedAt).getTime())));
                }
                const startDateFormatted = this.datePipe.transform(this.startDate, "dd-mm-yy");
                const endDateFormatted = this.datePipe.transform(this.endDate, "dd-mm-yy");
                this.filename += `_${startDateFormatted}_${endDateFormatted}`;
            }

            this.gridView = process(this.data, this.state);
        });
    }

    dataStateChange(state: DataStateChangeEvent) {
        this.state = state;
        this.gridView = process(this.data, this.state);
    }
}
